// @ts-nocheck

import { downloadRequestWithToken, fetchRequest } from './index';
import { convertFromMToKm } from '../pure/unitConversions';
const convertFromServer = reportItem => ({
  ...reportItem,
  kilometrage: convertFromMToKm(reportItem.kilometrage)
});

/**
 * Получение отчета
 */
export const fetchReportVehicleWorks = async params => {
  const report = await fetchRequest.get('/report/vehicle-works', {
    ...params
  });
  return report.map(convertFromServer);
};

/**
 * Печать отчета
 */
export const printReportVehicleWorks = async params => {
  const isPrinted = await downloadRequestWithToken('/report/vehicle-works/print', {
    ...params
  });
  if (isPrinted) return true;
  throw new Error('Не удалось загрузить отчет');
};
export default {
  fetchReportVehicleWorks,
  printReportVehicleWorks
};
